const RECAPTCHA_SITE_KEY = "6LdvuHgsAAAAAMTHX-iXel0ZRmbg6SSApM-78EpV";
const RECAPTCHA_SCRIPT_URL = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;

let scriptPromise = null;
let scriptElement = null;

const loadRecaptchaScript = () => {
  if (scriptPromise) {
    return scriptPromise;
  }

  if (window.grecaptcha?.enterprise) {
    scriptPromise = Promise.resolve();
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = RECAPTCHA_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Falha ao carregar reCAPTCHA"));
    document.head.appendChild(script);
    scriptElement = script;
  });

  return scriptPromise;
};

export const cleanupRecaptcha = () => {
  if (scriptElement) {
    scriptElement.remove();
    scriptElement = null;
  }
  scriptPromise = null;
  
  const badge = document.querySelector('.grecaptcha-badge');
  if (badge) {
    badge.remove();
  }
  
  delete window.grecaptcha;
};

export const executeRecaptcha = async (action) => {
  await loadRecaptchaScript();

  return new Promise((resolve, reject) => {
    window.grecaptcha.enterprise.ready(async () => {
      try {
        const token = await window.grecaptcha.enterprise.execute(
          RECAPTCHA_SITE_KEY,
          { action }
        );
        resolve(token);
      } catch (error) {
        reject(error);
      }
    });
  });
};
